import { ethers } from 'ethers';
import { appConfig } from 'config';

export const rpcProvider = ethers.getDefaultProvider(appConfig.networkId, { infura: appConfig.infuraId });
